// utils/weather.js
export const fetchWeather = async (lat, lon, apiKey) => {
  try {
    const url = `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&appid=${apiKey}&units=metric&lang=ja`;
    console.log("Fetching weather:", url); // ✅ URL確認

    const res = await fetch(url);
    if (!res.ok) {
      console.error("APIエラー:", res.status, res.statusText);
      return { condition: "取得失敗", temp: null, wind: null, icon: null };
    }

    const data = await res.json();
    console.log("Weather response:", data); // ✅ レスポンス確認

    return {
      condition: data.weather?.[0]?.description || "不明",
      temp: data.main?.temp?.toFixed(1) ?? null, // 小数1桁に整形
      wind: data.wind?.speed ?? null,
      icon: data.weather?.[0]?.icon || null,     // ★ アイコンコード追加
      iconUrl: data.weather?.[0]?.icon
        ? `https://openweathermap.org/img/wn/${data.weather[0].icon}@2x.png`
        : null                                   // ★ アイコンURL追加
    };
  } catch (err) {
    console.error("天気取得失敗:", err);
    return { condition: "取得失敗", temp: null, wind: null, icon: null, iconUrl: null };
  }
};

export const fetchWeatherForecast = async (lat, lon, apiKey) => {
  try {
    const url = `https://api.openweathermap.org/data/2.5/forecast?lat=${lat}&lon=${lon}&appid=${apiKey}&units=metric&lang=ja`;
    const res = await fetch(url);
    if (!res.ok) {
      console.error("APIエラー:", res.status, res.statusText);
      return [];
    }
    const data = await res.json();
    return data.list; // 3時間ごとの予報配列
  } catch (err) {
    console.error("天気予報取得失敗:", err);
    return [];
  }
};

